import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { Permission, hasPermission } from "../../utils/validatePermissions";

/**
 * The four dedicated scheduled-action permissions, resolved once. Centralized
 * here so every scheduled-action surface (lift/bank control panels, the org
 * drawer) shares one source of truth for the tree_keys instead of repeating the
 * four validatePermission calls. View gates visibility/fetch; create/update/
 * delete gate the corresponding controls.
 */
export interface ScheduledActionPermissions {
  canView: boolean;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
}

export function useScheduledActionPermissions(): ScheduledActionPermissions {
  const { permissionSet } = useSelector((state: RootState) => state.user);

  return {
    canView: hasPermission(Permission.ScheduledActionsView, permissionSet ?? []),
    canCreate: hasPermission(Permission.ScheduledActionsCreate, permissionSet ?? []),
    canUpdate: hasPermission(Permission.ScheduledActionsUpdate, permissionSet ?? []),
    canDelete: hasPermission(Permission.ScheduledActionsDelete, permissionSet ?? []),
  };
}

export default useScheduledActionPermissions;
